/** Enumeration of possible default value types for dashboard inputs. */
export default {
    /* Default to a static value */
    STATIC: "STATIC",

    /* default to a macro */
    MACRO: "MACRO",

    /* default to a datasource (may have inputs) */
    DATASOURCE: "DATASOURCE",

    /* default to the first value returned from a datasource (lists only) */
    FIRST: "FIRST",

    /* default to a specific item in the list (lists only) */
    SPECIFIC: "SPECIFIC",

    /* default to a placeholder prompt (lists only) */
    PROMPT: "PROMPT",

    /** default to 'none' with no placeholder (multi select and lists only) */
    NONE: "NONE"
};